const ArticlesState = {
  DRAFT_ARTICLES: "DraftArticles",
  SUBMITTED_ARTICLES: "SubmittedArticles",
  APPROVED_ARTICLES: "ApprovedArticles",
  QUEUED_ARTICLES: "QueuedArticles",
  LIVE_ARTICLES: "LiveArticles",
}
export default ArticlesState;
